import { createApi } from '@reduxjs/toolkit/query/react';
import reducerPath from '../../../app/reducerPath';
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from '../../baseQueryWithReAuth/baseQueryWithReAuth';
import HttpMethods from '../../../shared/api/HttpMethods';
import checkStatus from '../../../shared/http/checkStatus';
import config from '../../../shared/api/config';

const SPOTS_COVERAGE = 'SPOTS_COVERAGE';

export const spotsApi = createApi({
  reducerPath: `${reducerPath.spotsResource}/api`,
  tagTypes: [SPOTS_COVERAGE],

  baseQuery: (...args) => baseQueryWithReAuth(...args, `${config.spotsUrl}`),

  endpoints: (builder) => ({
    getCoverage: builder.query({
      query: () => ({
        url: `/spots/coverage`,
        method: HttpMethods.GET,
        validateStatus: checkStatus,
      }),
      providesTags: [SPOTS_COVERAGE],
    }),
  }),
});

export const { useGetCoverageQuery } = spotsApi;
